import { Box, Divider, Stack, Typography, useTheme } from '@mui/material'

const ColoringUtilization = () => {
  const theme = useTheme()

  return (
    <Stack p={2} spacing={1}>
      <Stack direction="row" spacing={1} flex={1} alignItems="center">
        <Box
          sx={{
            width: 10,
            height: 10,
            backgroundColor: theme.results.utilization.overutilized.light as string,
            borderRadius: 10,
          }}
        />
        <Box>
          <Typography>Hohe Ausnutzung</Typography>
        </Box>
      </Stack>

      <Divider />

      <Stack direction="row" spacing={1} flex={1} alignItems="center">
        <Box
          sx={{
            width: 10,
            height: 10,
            backgroundColor: theme.results.utilization.slightlyOverutilized.light as string,
            borderRadius: 10,
          }}
        />

        <Box>
          <Typography>Mittlere Ausnutzung</Typography>
        </Box>
      </Stack>

      <Divider />

      <Stack direction="row" spacing={1} flex={1} alignItems="center">
        <Box
          sx={{
            width: 10,
            height: 10,
            backgroundColor: theme.results.utilization.underutilized.main as string,
            borderRadius: 10,
          }}
        />

        <Box>
          <Typography>Niedrige Ausnutzung</Typography>
        </Box>
      </Stack>
    </Stack>
  )
}

export default ColoringUtilization
